import { useCallback } from 'react'
import { SsoMicrosoftApi } from '../../api/ssoMicrosoftApi'

export default function useMicrosoftConnect () {
  const getSecureUrl = async () => {
    try {
      const { data } = await SsoMicrosoftApi.getSecureUrl()
      return data.token
    } catch (e) {
      console.log(e)
    }
  }

  const connectMicrosoft = useCallback(async () => {
    try {
      const token = await getSecureUrl()
      if (!token) throw new Error('Missing Microsoft SSO token')
      const url = `${process.env.REACT_APP_STORE_URL}/auth/sso/microsoft/connect?token=${encodeURIComponent(token)}`
      window.open(url, '_blank', 'noopener,noreferrer')
    } catch (e) {
      console.log(e)
    }
  }, [])

  return { connectMicrosoft }
}
